import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button as MuiButton,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGlobalState } from "../../contexts/GlobalContext";

import {
  getClipping,
  deleteClipping,
  postClipping,
} from "../../utils/helpers/api";

interface IClippingItem {
  id: number;
  title: string;
  url: string;
  create_datetime: string;
}

const Clipping: React.FC = () => {
  const { t } = useTranslation();
  const { setStateValue } = useGlobalState();
  const [clippingList, setClippingList] = useState<IClippingItem[]>([]);
  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    document.title = "宣伝会議 : アカウント管理 | 保存した記事一覧  ";
    // postClipping()
  }, []);

  useEffect(() => {
    handleFetchClipping();
  }, []);

  const handleFetchClipping = async () => {
    setStateValue("loader", true);
    try {
      const result = await getClipping();
      if (result.status === 200) {
        if (result.data && Array.isArray(result.data)) {
          setClippingList(result.data);
        }
      }
    } catch (err) {
      console.error("Error fetching clipping:", err);
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleDeleteClipping = async (id: number) => {
    setStateValue("loader", true);
    try {
      const res = await deleteClipping(id);
      if (res.status === 200) {
        await handleFetchClipping();
        setOpenConfirm(true);
      }
    } catch (err) {
      console.error("Error deleting clipping:", err);
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  const sendenkaigiList = clippingList.filter((item) =>
    item.url.includes("sendenkaigi.com")
  );
  const kankyoList = clippingList.filter((item) =>
    item.url.includes("kankyo-business.jp")
  );

  return (
    <Box className="page__setting-password">
      <div>
        <div className="header-tit">保存した記事一覧</div>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {clippingList.length}件の保存した記事があります
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          ※最大100件まで記事を保存できます。101件目を保存すると、保存日が最も古い記事から順に削除されます。
        </Typography>

        <>
          {/* <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ mb: 1, ml: "20px", fontSize: "20px", color: "#007383" }}
          >
            宣伝会議の記事
          </Typography> */}

          {sendenkaigiList.length > 0 ? (
            sendenkaigiList.map((item) => (
              <Box
                key={item.id}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  borderBottom: "1px solid #ccc",
                  py: 1,
                  mb: 1,
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  sx={{
                    ml: "40px",
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "black",
                  }}
                  component="a"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.title}
                </Typography>
                <Box className="center">
                  <Button
                    style={{
                      backgroundColor: "#007383",
                      width: "80px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "14px",
                      borderRadius: "6px",
                      padding: 0,
                      marginRight: "20px",
                    }}
                    className="btn form-control btn-md submit"
                    onClick={() => handleDeleteClipping(item.id)}
                  >
                    削除
                  </Button>
                </Box>
              </Box>
            ))
          ) : (
            <></>
          )}
        </>

        <>
          {/* <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ mt: 3, mb: 1, ml: "20px", fontSize: "20px", color: "#007383" }}
          >
            環境ビジネスの記事
          </Typography> */}

          {kankyoList.length > 0 ? (
            kankyoList.map((item) => (
              <Box
                key={item.id}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  borderBottom: "1px solid #ccc",
                  py: 1,
                  mb: 1,
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  sx={{
                    ml: "40px",
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "black",
                  }}
                  component="a"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.title}
                </Typography>
                <Box className="center">
                  <Button
                    style={{
                      backgroundColor: "#007383",
                      width: "80px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "14px",
                      borderRadius: "6px",
                      padding: 0,
                      marginRight: "20px",
                    }}
                    className="btn form-control btn-md submit"
                    onClick={() => handleDeleteClipping(item.id)}
                  >
                    削除
                  </Button>
                </Box>
              </Box>
            ))
          ) : (
            <></>
          )}
        </>

        {/* Confirm Dialog */}
        <Dialog
          open={openConfirm}
          onClose={handleCancelDelete}
          PaperProps={{
            sx: {
              width: 300,
              height: 100,
              borderRadius: "12px",
              p: 2,
              pt: 0,
              overflow: "visible",
            },
          }}
        >
          <DialogTitle sx={{ position: "relative" }}>
            <IconButton
              aria-label="close"
              onClick={handleCancelDelete}
              sx={{
                position: "absolute",
                right: -25,
                top: -15,
                padding: "4px",
                bgcolor: "white",
                border: "1px solid #ccc",
                borderRadius: "4px",
                boxShadow: 1,
                "&:hover": {
                  bgcolor: "#f5f5f5",
                },
              }}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ mt: 1 }}>
            <Typography>記事を削除しました。</Typography>
          </DialogContent>
        </Dialog>
      </div>
    </Box>
  );
};

export default Clipping;